
const digest = '4989c5de38761d51d071a23e0b670af8ddceaf0022396f3ab6321e1fc07a41fd';
const classes = {"wrapper":"_wrapper_1ym00_1","hero":"_hero_1ym00_12","content":"_content_1ym00_20","badge":"_badge_1ym00_26","title":"_title_1ym00_39","button":"_button_1ym00_47","mockWrapper":"_mockWrapper_1ym00_56","cardGrid":"_cardGrid_1ym00_59","howItWorks":"_howItWorks_1ym00_64","subtitle":"_subtitle_1ym00_75","steps":"_steps_1ym00_80","line":"_line_1ym00_87","step":"_step_1ym00_80","number":"_number_1ym00_100","stepTitle":"_stepTitle_1ym00_113","stepText":"_stepText_1ym00_116"};
const css = `._wrapper_1ym00_1 {
  font-family: Rubik, sans-serif;
  height: 100%;
  overflow-y: auto;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 50px;
  padding: 24px;
  border: 1px solid #eaedf3;
}
._wrapper_1ym00_1 ._hero_1ym00_12 {
  background: #f3f4f5;
  padding: 40px;
  border-radius: 25px;
  display: flex;
  flex-direction: row;
  gap: 40px;
}
._wrapper_1ym00_1 ._hero_1ym00_12 ._content_1ym00_20 {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;
}
._wrapper_1ym00_1 ._hero_1ym00_12 ._content_1ym00_20 ._badge_1ym00_26 {
  width: fit-content;
  border-radius: 25px;
  background: #d9e2ff;
  color: #001a43;
  padding: 6px 12px;
  font-weight: 500;
  font-size: 14px;
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
}
._wrapper_1ym00_1 ._hero_1ym00_12 ._content_1ym00_20 ._title_1ym00_39 {
  font-size: 50px;
  font-weight: 700;
  line-height: 60px;
}
._wrapper_1ym00_1 ._hero_1ym00_12 ._content_1ym00_20 ._title_1ym00_39 span {
  color: #1d65d8;
}
._wrapper_1ym00_1 ._hero_1ym00_12 ._content_1ym00_20 ._button_1ym00_47 {
  font-size: 18px;
  font-weight: 600;
  background: linear-gradient(135deg, #1e6ce3 0%, #0054bc 100%);
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
  margin-top: 30px;
}
._wrapper_1ym00_1 ._hero_1ym00_12 ._mockWrapper_1ym00_56 {
  flex: 1;
}
._wrapper_1ym00_1 ._cardGrid_1ym00_59 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 20px;
}
._wrapper_1ym00_1 ._howItWorks_1ym00_64 {
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;
}
._wrapper_1ym00_1 ._howItWorks_1ym00_64 ._title_1ym00_39 {
  text-align: center;
  font-size: 32px;
  font-weight: 600;
}
._wrapper_1ym00_1 ._howItWorks_1ym00_64 ._subtitle_1ym00_75 {
  color: #424754;
  font-size: 18px;
  text-align: center;
}
._wrapper_1ym00_1 ._howItWorks_1ym00_64 ._steps_1ym00_80 {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  justify-content: space-between;
  grid-gap: 50px;
  max-width: 90%;
}
._wrapper_1ym00_1 ._howItWorks_1ym00_64 ._steps_1ym00_80 ._line_1ym00_87 {
  height: 1px;
  background: #e2e8f0;
  width: 100%;
  margin: auto 0;
}
._wrapper_1ym00_1 ._howItWorks_1ym00_64 ._steps_1ym00_80 ._step_1ym00_80 {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 10px;
}
._wrapper_1ym00_1 ._howItWorks_1ym00_64 ._steps_1ym00_80 ._step_1ym00_80 ._number_1ym00_100 {
  background: #ffffff;
  color: #0054bc;
  font-size: 32px;
  border: 1px solid #0054bc;
  border-radius: 100%;
  height: 100px;
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}
._wrapper_1ym00_1 ._howItWorks_1ym00_64 ._steps_1ym00_80 ._step_1ym00_80 ._stepTitle_1ym00_113 {
  font-weight: 600;
}
._wrapper_1ym00_1 ._howItWorks_1ym00_64 ._steps_1ym00_80 ._step_1ym00_80 ._stepText_1ym00_116 {
  color: #424754;
  font-size: 14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  